import { SortType } from './constant/sort-types.enum';

export class TableCellDescriptor {

    constructor(
        public headline: string,
        public fieldName: string,
        public pipeName: string,
        public sortable: boolean,
        public sortType: SortType,
        public width: string,
        public pk: boolean = false,
        public hoverTextFn: Function = null,
        public tooltip = ''
    ) {
    }

}
